<template>
  <section class="help-suggestions">
    <h3>{{ title }}</h3>
    <p v-if="loading">正在加载帮助…</p>
    <ErrorNotice v-else-if="error" :message="error"><button type="button" @click="load(false)">重试</button></ErrorNotice>
    <template v-else>
      <template v-if="selected">
        <button type="button" @click="selected = null">返回问题列表</button>
        <h4>{{ selected.title }}</h4>
        <a v-if="articleLink" :href="articleLink">查看帮助内容</a>
        <div v-else v-html="sanitizeHelpContent(selected.content)" />
      </template>
      <template v-else>
        <button v-for="item in items" :key="item.id" type="button" @click="open(item)">{{ item.title }}</button>
        <p v-if="!items.length">暂无已发布帮助</p>
        <button v-if="items.length < total" type="button" @click="load(true)">加载更多</button>
      </template>
    </template>
  </section>
</template>
<script setup>
import ErrorNotice from './feedback/ErrorNotice.vue'
import { computed, onMounted, ref, watch } from 'vue'
import { webApi } from '../services/webApi'
import { useAppContext } from '../composables/appContext'
const { sanitizeHelpContent } = useAppContext()
const props = defineProps({ title: { type: String, default: '相关帮助' }, newbieOnly: Boolean, relatedScene: { type: Number, default: 0 } })
const items = ref([]), selected = ref(null), loading = ref(false), error = ref(''), total = ref(0), page = ref(0)
let version = 0
const articleLink = computed(() => { try { const url = new URL(selected.value?.content || ''); return /^https?:$/.test(url.protocol) ? url.href : '' } catch { return '' } })
async function load(append = false) {
  const requestId = ++version
  if (!append) { items.value = []; selected.value = null; page.value = 0; total.value = 0 }
  loading.value = true; error.value = ''
  try {
    const result = await webApi.helpArticles({ pageNumber: page.value + 1, pageSize: 10, siteType: 1, newbieOnly: props.newbieOnly, ...(props.relatedScene ? { relatedScene: props.relatedScene } : {}) })
    if (requestId !== version) return
    items.value = append ? [...items.value, ...(result?.data || [])] : result?.data || []; total.value = result?.total || 0; page.value += 1
  } catch (failure) { if (requestId === version) error.value = failure.message || '帮助加载失败' }
  finally { if (requestId === version) loading.value = false }
}
async function open(item) {
  if (loading.value) return
  const requestId = ++version; loading.value = true; error.value = ''
  try { const detail = await webApi.helpArticleDetail(item.id); if (requestId === version) selected.value = detail }
  catch (failure) { if (requestId === version) error.value = failure.message || '帮助加载失败' }
  finally { if (requestId === version) loading.value = false }
}
onMounted(() => load())
watch(() => [props.newbieOnly, props.relatedScene], () => load())
</script>
<style scoped>
.help-suggestions { margin: 24px auto; max-width: 1200px; padding: 24px; background: #fff; border: 1px solid #e3e8ef; color: #303442; }
h3 { margin: 0 0 16px; font-size: 20px; }
button { display: block; padding: 12px 0; color: #2765b0; background: transparent; border: 0; cursor: pointer; text-align: left; }
button:focus-visible, a:focus-visible { outline: 2px solid #2765b0; outline-offset: 3px; }
</style>
